import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, SubmissionError } from 'redux-form'
import { Breadcrumb, Confirm, Button, Icon, Modal } from 'semantic-ui-react'

import { ProcurementContainer, ProcurementBody } from '../../styled'
import { MainBodyContent, CustomButton, K2ErrorModal } from 'components'
import { purchaseOrderPath } from 'routes'
import DocumentStep from '../../Shared/DocumentStep'
import { BottomActionsContainer } from './styled'
import { scrollToFirstValidateFailElement } from 'core/utilities'

import { getHrmsMembers, getPurchaseUsers, getAllMembers } from 'ducks/member'
import RequestInformation from '../Shareds/RequestInformation'
import Summary from '../Shareds/Summary'
import General from '../Shareds/General'
import Detail from '../Shareds/Detail'
import Attachment from '../Shareds/Attachment'
import Comment from '../Shareds/Comment'
import ActionCommentModal from '../Shareds/ActionCommentModal'
import {
  validateField,
} from '../helper'
import { 
  getPoDetail, 
  getPoApprover,
  updatePO,
  submitPO,
  resubmitPO,
  resubmitToVendorPO,
  approverPOAction,
  getPOErrorWorkFlow
} from 'ducks/purchaseOrder'

const PurchaseOrderDetail = (props) => {
  const { history, valueForm, approvers, poDetail, poSAPData, k2workFlowError, change, handleSubmit, isDetail = false } = props

  const [showConfirm, setShowConfirm] = React.useState(false)
  const [actionName, setActionName] = React.useState('')
  const [showDialogComment,setShowDialogComment] = React.useState(false)
  const [showAlertDPChange,setShowAlertDPChange] = React.useState(false)
  const [showAlertDPDeleted,setShowAlertDPDeleted] = React.useState(false)
  const [showAlertDPAdded,setShowAlertDPAdded] = React.useState(false)

  React.useEffect(()=>{
    let poId = props.match.params.poId
    props.getPoDetail(poId, history, false)
    props.getAllMembers(isDetail)
    // props.getHrmsMembers(isDetail)
  },[])

  React.useEffect(()=>{
    if(valueForm.id){
      props.getPoApprover(valueForm.id)
    }
  },[valueForm&&valueForm.id])

  React.useEffect(()=>{
    if(Object.keys(valueForm).length>0){
      if(valueForm.companyCode&& valueForm.purchGroup){
        props.getPurchaseUsers(valueForm.companyCode, valueForm.purchGroup)
      }
    }
  },[valueForm.companyCode])

  React.useEffect(() => {
    if (valueForm&&valueForm.status&&valueForm.status!==0) {
      props.getPOErrorWorkFlow(valueForm.procInstId, valueForm.subProcInstId)
    }
  },[valueForm&&valueForm.status])
  
  React.useEffect(()=>{
    if(Object.keys(poSAPData).length>0){
      //old po has DP
      if(poDetail.downPaymentType&&poDetail.downPaymentType.trim()!='N'){
        if(!poSAPData.downPaymentType || poSAPData.downPaymentType=='N'){
          setShowAlertDPDeleted(true)
        }else {
          if(poDetail.downPaymentRate != poSAPData.downPaymentRate 
            || poDetail.downPaymentAmount != poSAPData.downPaymentAmount 
            || poDetail.downPaymentVatRate != poSAPData.downPaymentVatRate
            || poDetail.downPaymentVatAmount != poSAPData.downPaymentVatAmount
            || poDetail.downPaymentNetAmount != poSAPData.downPaymentNetAmount 
          ){
            setShowAlertDPChange(true)
          }
        }
      }else{//old DP not has DP
        if(poSAPData.downPaymentType&&poSAPData.downPaymentType.trim()=='M'){
          setShowAlertDPAdded(true)
        }
      }
    }
  },[poSAPData])

  const onSubmitForm = () => {
    setShowConfirm(false)
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
    return sleep(100)
    .then(() => {
      let errors = validateField(valueForm, actionName)
      if(Object.keys(errors).length){
        scrollToFirstValidateFailElement(errors)
        throw new SubmissionError(errors)
      }else{
        setShowDialogComment(false)
        if(actionName.toLowerCase()=='save'){
          props.updatePO(valueForm,history)
        }
        if(actionName.toLowerCase()=='submit'){
          props.submitPO(valueForm,history)
        }
        if(actionName.toLowerCase()=='cancel'){
          props.approverPOAction({
            ...props.valueForm,
            docId: valueForm.id,
            sn: valueForm.sn,
            action: actionName,
            comment:valueForm.actionComment
          },history)
        }
        if(actionName.toLowerCase()=='submittovendor'){
          props.resubmitToVendorPO({...valueForm,actionName:actionName},history)
        }
        if(actionName.toLowerCase()=='resubmit'){
          props.resubmitPO({...valueForm,actionName:actionName},history)
        }
      }
    })
  } 
  
  return (
    <MainBodyContent
  headerTitle={<React.Fragment>{valueForm.isSpecialCreditTerm&&<Icon size='tiny' name='star' color='yellow'/>}{`Purchase Orders - ${valueForm.documentNumber ? valueForm.documentNumber : 'Detail'}`}</React.Fragment>}
      accessoriesHeader={
        <div style={{ display: 'flex' }}>
          {
            valueForm.urlPrintFormPo ?
            <Button 
              basic  
              circular 
              type='button' 
              content='View PO form' 
              labelPosition='right'
              icon='clipboard list' 
              onClick={()=>(window.open(valueForm.urlPrintFormPo,"_blank"))}/> : null
          }
          <CustomButton 
            onClick={() => history.push(purchaseOrderPath)}
            icon='close'
            btnColor='red'
            title='Close'/>
          </div>
        }
      breadcrumbs={
        <Breadcrumb 
          icon='right angle' 
          sections={[
            { key: 'PO', content: 'Purchase Orders', link: true, onClick: () => history.push(purchaseOrderPath) },
            { key: 'PO_Detail', content: valueForm.documentNumber ? valueForm.documentNumber : 'Detail', active: true }
          ]}
        />
      }
      accessoriesHeaderLeft={
        k2workFlowError.isError&&
          <K2ErrorModal checkK2Error={k2workFlowError}/>  
      }
    > 
      <ProcurementContainer>
        <ProcurementBody>
          <DocumentStep documentDetail={{ ...valueForm }} approvers={approvers} />
          <RequestInformation isNewVersion={valueForm.isNewVersion} />
          <Summary/>
          <General/>
          <Detail/>
          <Attachment isEdit change={change} handleSubmit={handleSubmit} history={history} />
          {valueForm&&valueForm.status!=0?
          <Comment/>:null}
          {valueForm&&<form onSubmit={props.handleSubmit(()=>onSubmitForm())}>
          {valueForm&&valueForm.status==0?
            <React.Fragment>
              {valueForm&&valueForm.printVersion>0&&valueForm.referencePurchaseOrderUpdateId?
                <BottomActionsContainer>
                  <Button 
                    type='button'
                    content='Save' 
                    icon='save' 
                    labelPosition='right'
                    style={{ marginRight: '0.3125rem' }}
                    onClick={()=>{
                      setActionName('save')
                      setShowConfirm(true)
                    }}
                  />
                  <Button 
                    type='button'
                    content='Save & Submit' 
                    color='blue' 
                    icon='save' 
                    labelPosition='right'
                    style={{ marginRight: '0.3125rem' }}
                    onClick={()=>{
                      setActionName('submit')
                      setShowConfirm(true)
                    }}
                  />
                </BottomActionsContainer>:null
              }
            </React.Fragment>
            :
            <BottomActionsContainer>
              {valueForm&&valueForm.approverAction&&valueForm.approverAction.map((a)=>{
                return( 
                  <Button 
                    type='button'
                    content={a} 
                    icon={a=='Cancel'?'close':'save'} 
                    labelPosition='right'
                    color={
                      a=='SubmitToVendor'?'green':
                      a=='Resubmit'?'blue':
                      a=='Cancel'?'red':
                      'grey'
                    }
                    style={{ marginRight: '0.3125rem' }}
                    onClick={()=>{
                      setActionName(a)
                      if(a=='Save'){
                        setShowConfirm(true)
                      }else{
                        setShowDialogComment(true)
                      }
                    }}
                  />
                )
              })}
            </BottomActionsContainer>}
          </form>}
        </ProcurementBody>
      </ProcurementContainer>
      {showDialogComment&&<ActionCommentModal submit={props.handleSubmit(()=>onSubmitForm())} setShowDialogComment={setShowDialogComment} actionName={actionName}/>}
      <Confirm
        size='tiny'
        open={showConfirm}
        onCancel={() => setShowConfirm(false)}
        onConfirm={props.handleSubmit(()=>onSubmitForm())}
      />
      <Modal
        open={showAlertDPChange}
        header={<div className='header' style={{color:'#FFCC00'}}>Alert!!</div>}
        closeOnDimmerClick={false}
        size='tiny'
        content={`This PO ${poDetail.sapNumber} has been changed down payment.`}
        actions={[{ key: 'ok', content: 'OK', positive: true, onClick:()=>setShowAlertDPChange(false)}]}
      />
      <Modal
        open={showAlertDPDeleted}
        header={<div className='header' style={{color:'#FFCC00'}}>Alert!!</div>}
        closeOnDimmerClick={false}
        size='tiny'
        content={`This PO ${poDetail.sapNumber} has been removed down payment.`}
        actions={[{ key: 'ok', content: 'OK', positive: true, onClick:()=>setShowAlertDPDeleted(false)}]}
      />
      <Modal
        open={showAlertDPAdded}
        header={<div className='header' style={{color:'#FFCC00'}}>Alert!!</div>}
        closeOnDimmerClick={false}
        size='tiny'
        content={`This PO ${poDetail.sapNumber} has been added down payment.`}
        actions={[{ key: 'ok', content: 'OK', positive: true, onClick:()=>setShowAlertDPAdded(false)}]}
      />
    </MainBodyContent>
  )
}

const mapStateToProps = (state) => {
  var valueForm = getFormValues('formPO')(state)
  var poDetail = state.po.poDetail.data
  var poSAPData = state.po.poSAPData.data
  let initialValues = {
    ...poDetail,
      vendorName: `${poDetail.vendorCode || ''} : ${poDetail.vendorName || ''}`
  }
  if(Object.keys(poSAPData).length>0){
    initialValues = {...poDetail,...poSAPData}
    initialValues.vendorName = `${poSAPData.vendorCode || ''} : ${poSAPData.vendorName || ''}`
  }
  return ({
    initialValues: initialValues,
    poSAPData,
    poDetail,
    poLoading: state.po.poDetail.loading,
    approvers: state.po.approvers.data,
    valueForm:valueForm||{},
    k2workFlowError: state.po.k2workFlowError,
  })
}

const mapDispatchToProps = {
  getPoDetail,
  getPoApprover,
  getHrmsMembers,
  getPurchaseUsers,
  updatePO,
  submitPO,
  resubmitPO,
  resubmitToVendorPO,
  approverPOAction,
  getPOErrorWorkFlow,
  getAllMembers
}

const contForm = reduxForm({
  form: 'formPO',
  enableReinitialize: true,
})(PurchaseOrderDetail)

export default connect(mapStateToProps, mapDispatchToProps)(contForm)
